<!--
 * @Author: Merlin
 * @Date: 2024-05-15 18:43:55
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-29 13:24:10
 * @Description: 
-->
<template>
    <NuxtLayout name="casino">
        <ClientOnly>
            <GameSettingsDiceTabsWrapper>
                <ClientOnly>
                    <GameSettingsButtonLiveChat v-if="userStore.isLoggedIn" v-model="isOpenLiveChat" />
                </ClientOnly>
                <GameSettingsButtonFast v-model="game.spacedice.fast" />
                <GameSettingsButtonFairness v-model="isOpenFairness" />
                <GameSettingsButtonRule v-model="isOpenRule" name="spaceDice" />
                <GameSettingsButtonVocie
                    v-model="settingStore.inhouseGames.sound.on"
                    v-model:voice-model-value="settingStore.inhouseGames.sound.music"
                    :saveAfterChange="true"
                >
                </GameSettingsButtonVocie>
            </GameSettingsDiceTabsWrapper>
        </ClientOnly>
        <!-- ↑ 游戏顶部的设定控件 -->
        <!-- ↓ 主要部分 -->
        <div class="relative">
            <CasinoGameBarJackpot
                game-name="Space Dice"
                :jackpotSize="globalStore?.jackpotSum['spacedice']"
            >
                <div class="w-full flex justify-between text-[#4d75a6]">
                    <ClientOnly>
                        <small
                            class="text-xs rounded-md bg-[rgba(0,9,19,.33)] px-1"
                            v-for="(item, ind) in Array.from({ length: 4 })"
                            :key="ind"
                            :class="{'active-jackpot': joinStore.jackpotDelay[ind]}"
                        >
                            {{ ind === 0 ? '7---' : '77--' }}
                        </small>
                    </ClientOnly>
                </div>
            </CasinoGameBarJackpot>
            <!-- ↓ 开奖历史 -->
            <HistoryBar></HistoryBar>
            <div
                class="w-full p-2 relative rounded-md bg bg-[rgb(1,27,58)] column rounded-borders overflow-hidden"
            >
                <!-- ↓摇奖区 -->
                <section class="board-mid">
                    <!-- ↓ 用于插入1个图 -->
                    <CasinoIcon ></CasinoIcon>
                    <div class="board-mid-container">
                        <ClientOnly>
                            <BetNumberVue
                                :ref="el => oBetNumber=el"
                                :sound="settingStore.inhouseGames.sound.on"
                                :sound-volume="settingStore.inhouseGames.sound.music" 
                                :fast-time="
                                    game.spacedice.fast
                                        ? spaceDiceConfig.fastTime
                                        : spaceDiceConfig.notFastTime
                                "
                                :max-model-value="labelRange.max"
                                :min-model-value="labelRange.min"
                                :config="spaceDiceConfig"
                                :is_in="isIn"
                                :betAmount="luckyNumber"
                                v-model:max-value="labelRange.max"
                                v-model:min-value="labelRange.min"
                            />
                        </ClientOnly>
                    </div>
                </section>
                <!-- ↓ 这是下方的滑竿组件容器 -->
                <div class="px-4"
                    :style="{'min-height': '125px'}"
                >
                    <ClientOnly>
                        <!-- <div v-if="sOverLimitPayout" class="over-limit-tips">
                            {{ sOverLimitPayout }}
                        </div> -->
                        <div class="flex flex-col relative justify-center">
                            <div class="w-full">
                                <SliderVue
                                    :isIn="isIn"
                                    v-model:label-range="labelRange"
                                    :lucky-number="luckyNumber"
                                    :bet-amount="oForm.amount"
                                    :is-submiting="oForm.isSubmiting"
                                    :is-animate="animation"
                                    :lastArrow="lastArrow"
                                >
                                    <template v-slot:noUISlider>
                                        <q-range
                                            v-model="labelRange"
                                            :min="spaceDiceConfig.min"
                                            :max="spaceDiceConfig.max"
                                            :inner-min="oLimit.min"
                                            :inner-max="oLimit.max"
                                            :readonly="oForm.isSubmiting"
                                            :step="1"
                                            :drag-range="draggable"
                                            :track-color="!isIn ? 'green' : 'red'"
                                            :color="isIn ? 'green' : 'red'"
                                            @change="fnRangeChange"
                                            @update:model-value="playWhileDraging"
                                            desc="↓以下是各种常量，恒定值"
                                            label-always
                                            switch-label-side
                                            :label-color="'secondary'"
                                            class="absolute inset-0 z-10 opacity-0"
                                            key="labelRange"
                                            thumb-color="white"
                                            thumb-size="80px"
                                            track-size="25px"
                                        />
                                    </template>
                                </SliderVue>
                            </div>
                        </div>
                    </ClientOnly>
                </div>
            </div>
            <!-- ↓返现倍率提示栏 -->
            <ClientOnly>
                <StatisticsVue
                    class="mt-2"
                    :bet-amount="oForm.amount"
                    @expected-reward="(value) => (expectedReward = value)"
                    :labelRange="labelRange"
                    :isIn="isIn"
                    :config="spaceDiceConfig"
                    :rtp="joinStore.config.rtp"
                    :limitPayout="joinStore.betttingLimits?.maxWin"
                />
            </ClientOnly>
            <!--
                ↑ 游戏舞台
                ↓ 输入框按钮等，用户操作区
            -->
            <ClientOnly>
                <CasinoBetOptionSection
                    :betTookit="betTookit"
                    :auto-bet-tool-kit="autoBetToolKit"
                    v-model:bet-amount-modal-value="oForm.amount"
                    v-model:is-submiting="oForm.isSubmiting"
                    :sound="settingStore.inhouseGames.sound.on"
                    :expectedReward="expectedReward"
                    :isAuto="game.spacedice.auto.default"
                    :bet-submit="betSubmit"
                    :is-fast="settingStore.game.spacedice.fast"
                    @change-mode="toChangeMode"
                />
            </ClientOnly>
        </div>
    </NuxtLayout>
    
    <!-- ↓ 自动下注的输入面板（弹窗） -->
    <CasinoAutoSection
        :ref="el => oAutoDialog=el"
        v-model:amount="oForm.amount"
        :is-fast="settingStore.game.spacedice.fast"
        :is-submiting="oForm.isSubmiting"
        :is-auto="game.spacedice.auto.default"
    />
    <ModalWinJackpotHandler
        :gameName="'spacedice'"
        :ref="ev => jackpotHandler = ev"
    />
</template>

<script lang="ts" >
export default defineComponent({name: 'SpaceDice'});
</script>

<script setup lang="ts">
import SpaceDiceSound from '@/assets/mp3/spaceDice/spacedice_background.mp3'
import SpaceDiceWinSound from '@/assets/mp3/spaceDice/spacedice_win.mp3';
import SpaceDiceLoseSound from '@/assets/mp3/spaceDice/spacedice_lose.mp3';
import SpaceDiceBetSound from '@/assets/mp3/spaceDice/spacedice_bet.mp3';
import spaceDiceDrag from '@/assets/mp3/spaceDice/spacedice_drag.mp3';
// ------- ↑ 音效 ↑ --------------------------------------  
import StatisticsVue from './_components/Statistics.vue';
import CasinoIcon from './_components/CasinoIcon.vue';
import HistoryBar from './_components/HistoryBar.vue';
import BetNumberVue from './_components/BetNumber/index.vue';
import SliderVue from './_components/Slider.vue';
// ------- ↑ vue 组件 ↑ -------------------------------------- 
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useUserStore } from '~/stores/user';
import useSettingsStore from '~/stores/settings';
import useGlobalStore from '@/stores/global';
import { useGameSocket } from '@/socket/game';
// ------- ↑ socket + store ↑ -------------------------------------- 
import { useAutoBetToolKit } from '~/common/js/bettingToolkit/auto';
import betHelper from '~/common/js/betHelper';
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import type { MoveType, LabelRange } from './js/composable';
import { sStoargeKey, useLabelRange, spaceDiceConfig, fnEditor } from './js/composable';
import { computed } from 'vue';


const isDev = import.meta.dev; 
const { EMIT_SPACEDICE_BET } = useGameSocket();
const settingStore = useSettingsStore();
const userStore = useUserStore();
const globalStore = useGlobalStore();
const { game, animation } = storeToRefs(settingStore);
const joinStore = useJoinStateStore();
const oLimit = reactive({ // 托运滑块时对范围进行限定，防止超限
    min: spaceDiceConfig.min,
    max: spaceDiceConfig.max,
});

const oBetNumber = ref(null);
const lastArrow = ref(0); // 0与1代表左侧被修改了或右侧 
const sMoveType:Ref<MoveType> = ref('');

const oForm = reactive({
    amount: 0,
    isSubmiting: false,
});
const betTookit = useBettingToolkit(oForm);

const luckyNumber = ref(5000);
const expectedReward = ref(0);
const isIn = ref(true);
const isOverLimit = ref(false);

const isOpenFairness = ref(false);
const isOpenRule = ref(false);
const isOpenLiveChat = ref(false);
const jackpotHandler = ref(null);

// 音乐列表
const oMusicLib = {
    bg:{
        src: SpaceDiceSound,
        loop: true,
        isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
        volumeOffset: 0.05,
    },
    bet:{ src: SpaceDiceBetSound, },
    win:{ src: SpaceDiceWinSound, },
    lose:{ src: SpaceDiceLoseSound, },
    drag:{ src: spaceDiceDrag, },
};
const oMusic = (
    import.meta.client
    && new MusicControler(oMusicLib as any)
);
const sounds = oMusic?.oAudio;


const labelRange = useLabelRange();
const draggable = computed(()=>{
    const iGap = Math.abs(
        labelRange.value.max - labelRange.value.min
    );
    return iGap >= 500 && !isOverLimit.value;
});

const rangeOptions = ref([
    { id: 'min', label: 'MIN' },
    { id: 'toMin', label: '-5%' },
    { id: 'auto', label: 'AUTO PICK' },
    { id: 'toMax', label: '+5%' },
    { id: 'max', label: 'MAX' },
]);

const currentOption = ref('min');

// ↓ 自动模式输入面板"窗口化改造" 添加的变量与方法：  
const oAutoDialog = ref(null); 
const toChangeMode = (isAuto) => { 
    // ↓按各个游戏的实际情况设定 
    settingStore.game.spacedice.auto.default = !!isAuto;
    if (isAuto){
        oAutoDialog.value.switchAutoDialogVisible(true);
    }
};


// ↓ 接收一个事件 ID（用户点击触发的事件）
const changeRang = (key) => {
    // console.log("事件:", key); 
    if (oForm.isSubmiting) return;
    playWhileDraging();
    let a, b, medium;
    currentOption.value = key;
    if (!!isIn.value) {
        switch (key) {
            case 'min':
                medium = Math.ceil((labelRange.value.min + labelRange.value.max) / 2);
                labelRange.value = {
                    min: medium,
                    max: medium,
                };
                break;
            case 'max':
                labelRange.value = {
                    min: 100,
                    max: 9599,
                };
                break;
            case 'toMin':
                a = labelRange.value.min + 250;
                b = labelRange.value.max - 250;
                if (a >= b) {
                    changeRang('min');
                } else {
                    labelRange.value = { min: a, max: b };
                }
                break;
            case 'toMax':
                a = labelRange.value.min - 250 < 0 ? 0 : labelRange.value.min - 250;
                b = labelRange.value.max + 250 > 9999 ? 9999 : labelRange.value.max + 250;
                if (b - a > 9499) {
                    changeRang('max');
                } else {
                    labelRange.value = { min: a, max: b };
                }
                break;
            case 'auto':
                a = Math.floor(Math.random() * 10000);
                b = Math.floor(Math.random() * 10000);
                if (a > b) {
                    [a, b] = [b, a];
                }
                if (b - a > 9499) {
                    b = a + 9499;
                }
                labelRange.value = { min: a, max: b };
                break;

            default:
                break;
        }
    } else {
        switch (key) {
            case 'min':
                labelRange.value = {
                    min: 0,
                    max: 9998,
                };
                break;
            case 'max':
                medium = Math.ceil((labelRange.value.min + labelRange.value.max) / 2);
                labelRange.value = {
                    min: medium - 250,
                    max: medium + 250,
                };
                break;
            case 'toMin':
                a = labelRange.value.min - 250 < 0 ? 0 : labelRange.value.min - 250;
                b = labelRange.value.max + 250 > 9999 ? 9999 : labelRange.value.max + 250;
                if (b - a > 9998) {
                    changeRang('min');
                } else {
                    labelRange.value = { min: a, max: b };
                }
                break;
            case 'toMax':
                a = labelRange.value.min + 250;
                b = labelRange.value.max - 250;
                if (b - a < 500) {
                    changeRang('max');
                } else {
                    labelRange.value = { min: a, max: b };
                }
                break;
            case 'auto':
                a = Math.floor(Math.random() * 10000);
                b = Math.floor(Math.random() * 10000);
                if (a > b) {
                    [a, b] = [b, a];
                }
                if (b - a < 500) {
                    b = a + 500;
                }
                labelRange.value = { min: a, max: b };
                break;

            default:
                break;
        }
    }
};

// ↓ 拖动划杆的回调 
const fnRangeChange = (value: any) => {
    if (oForm.isSubmiting) return;
    playWhileDraging();
    fnRestoreLimit(); // 释放限定
    isDev && console.log('滑动完毕：', value.min, value.max); 
    if (isDev && (value.min != labelRange.value.min) || (value.max != labelRange.value.max)) {
        console.log("=> min:", value.min, labelRange.value.min);
        console.log("=> max:", value.max, labelRange.value.max);
        
    }
    let { min, max } = value;
    let oNewRange = {};
    const oPlan01 = fnRangeChecker(value); // 修复方案 01
    if (oPlan01){
        // 经过以下赋值，两值均合法。 oNewRange 将永远为空 
        min = oPlan01.min ?? min;
        max = oPlan01.max ?? max;
    }
    if (isIn.value) {
        const maxBuffer = spaceDiceConfig.max - max;
        const minBuffer = min - spaceDiceConfig.min;
        const range = maxBuffer + minBuffer;
        if (range < 500) {
            if (maxBuffer >= minBuffer) {
                oNewRange = {
                    min: spaceDiceConfig.min,
                    max: spaceDiceConfig.max - 500,
                };
            } else {
                oNewRange = {
                    max: spaceDiceConfig.max,
                    min: spaceDiceConfig.min + 500,
                };
            }
        }
    } else {
        const range = max - min;
        if (max === spaceDiceConfig.max && min === spaceDiceConfig.min) {
            const iMoveMark = lastArrow.value; // 0，1 分别代表左侧滑动右侧滑动 
            oNewRange = [
                {min: 1, max: spaceDiceConfig.max },
                {min: 0, max: spaceDiceConfig.maxScopeOut },
            ][iMoveMark];
        } else if (range < 500) {
            if (min - 500 < 0) {
                oNewRange = {
                    max: 499,
                    min: 0,
                };
            } else if (max + 500 > 9999) {
                oNewRange = {
                    max: 9999,
                    min: 9499,
                };
            } else {
                const addValue = 500 - range;
                oNewRange = {
                    max: max + addValue,
                    min: min,
                };
            }
        }
    }
    if (!oPlan01 && (typeof oNewRange['min'] == 'undefined')) {
        // console.log("数值合规，不必修正 ✔✔", min, max); 
        Object.assign(labelRange.value, value);
        return;
    }
    console.log("修正方案1: 💥", JSON.stringify(oPlan01)); 
    console.log("修正方案2: 💥", JSON.stringify(oNewRange)); // 估计永远没有方案2
    setTimeout(() => {
        Object.assign(labelRange.value, {
            min,
            max,
        });
        fnRestoreLimit(); // 释放限定
    }, 100);
};

// ↓ 下注的方法
const betSubmit = async () => {
    if (!betHelper.betableCheck(oForm.amount)) return;
    const predictionRange = [labelRange.value.min, labelRange.value.max];
    playBetSound();
    const ts = userStore.queueStart(); // 防止余额立即变化 
    oBetNumber.value.fnStopInputing(); // 关闭上方的数字输入框 
    let amount = getFixed(oForm.amount, 2);
    // if (import.meta.env.DEV_MODE && Math.random() <= 0.2 && settingStore.game.spacedice.auto.default){ 
    //     amount = '0'; 
    // }
    const res = await EMIT_SPACEDICE_BET({
        amount,
        frontID: Date.now(),
        isFast: settingStore.game.spacedice.fast,
        isIn: isIn.value,
        predictionRange,
    });
    if (!res || res['error']){
        userStore.queueDelete(ts);
        if (settingStore.game.spacedice.auto.default == false){
            // 仅为手动模式弹出，自动模式在方法包内弹出 
            showNegativeNotify(res?.['error']); 
        }
        return res;
    }
    if (res?.response) {
        res.response.amount ??= oForm.amount;
    }
    if (isDev) {
        console.log('spaceDice 下注结果：\n', res?.response);
    }
    luckyNumber.value = Number(res.response.roll_number);
    const {fast} = game.value.spacedice;
    const {fastTime, notFastTime} = spaceDiceConfig;
    let iSleepTime02 = fast ? fastTime : notFastTime;
    await Sleep(iSleepTime02); 
    const hasWon = Number(res.response.winAmount) > 0;
    playResultSound(hasWon);
    await Sleep(90); 
    userStore.queueForward(ts); // 显示余额变化
    joinStore.showDateInQueue(); // 插入游戏结果
    joinStore.jackpotUpdate();
    const hasWonJP = jackpotHandler.value?.showJackpotWin?.();
    if (settingStore.game.spacedice.auto.default == false){ 
        oForm.isSubmiting = false;
    }else if(hasWonJP){
        await Sleep(5_000);
        jackpotHandler.value?.hideJackpotWin();
    }
    return res.response;
};

let dragTimer = 0;
const playWhileDraging = () => {
    if (Date.now() - dragTimer < 150){
        return; // 节流
    }
    dragTimer = Date.now();
    sounds.drag.toPlay();
};


const autoBetToolKit = useAutoBetToolKit(oForm, betSubmit);


// ↓ 主要用于在滑动时限定滑动范围
watch(
    labelRange,
    (newVal, oldVal) => {
        0 && console.log("动了动了：oLimit", JSON.stringify(oLimit), '----------');
        const leftMoving = (newVal.min != oldVal?.min); 
        const rightMoving = (newVal.max != oldVal?.max); 
        // console.log("min:", leftMoving, newVal.min, oldVal.min); 
        // console.log("max:", rightMoving, newVal.max, oldVal.max); 
        if (leftMoving && !rightMoving){
            oLimit.max = newVal.max;
            lastArrow.value = 0;
            const isGoingRight = newVal.min > oldVal?.min;
            sMoveType.value = isGoingRight ? 'lr' : 'll';
            const theMost = fnEditor(sMoveType.value, isIn.value, newVal);
            if (isGoingRight) {
                oLimit.min = 0; // 左球右行 →，左侧自由 
                if (newVal.min > theMost) labelRange.value.min = theMost;
            }else{
                oLimit.min = Math.max(theMost, 0);
                if (newVal.min < theMost) labelRange.value.min = theMost;
            }
        }else if (!leftMoving && rightMoving){ // 反之左边无变化，"右" 侧在拖动
            oLimit.min = newVal.min;
            lastArrow.value = 1;
            const isGoingRight = newVal.max > oldVal?.max;
            sMoveType.value = isGoingRight ? 'rr' : 'rl';
            const theMost = fnEditor(sMoveType.value, isIn.value, newVal);
            if (isGoingRight) {
                oLimit.max = theMost; 
                if (newVal.max > theMost) labelRange.value.max = theMost;
            }else{
                oLimit.max = spaceDiceConfig.max; // 右球左行 ←，右侧自由 
                if (newVal.max < theMost) labelRange.value.max = theMost;
            }
        }else if(!leftMoving && !rightMoving){
            1 && console.log("[没有变动]");
        }else{
            sMoveType.value = '';
            fnRestoreLimit(); // 释放限定
        }
        // console.log("移动类型总结：", sMoveType.value || 'Whole');
        fnRecorder(newVal);
    },
);

// ↓ 滑动结束后，计算修正方案（或为空） 
function fnRangeChecker( newVal ){
    const [sideMoving, direction] = sMoveType.value;
    if (!sideMoving) return;
    const isGoingRight = direction === 'r';
    const theMost = fnEditor(sMoveType.value, isIn.value, newVal);
    if (sideMoving === 'l'){
        if (isGoingRight) {
            if (newVal.min > theMost) return {min: theMost};
        }else{
            if (newVal.min < theMost) return {min: theMost};
        }
    }else if (sideMoving === 'r'){
        if (isGoingRight) {
            if (newVal.max > theMost) return {max: theMost};
        }else{
            if (newVal.max < theMost) return {max: theMost};
        }
    }
}

// ↓ 播放滑动范围的限定 
function fnRestoreLimit(){
    oLimit.min = void 0;
    oLimit.max = void 0;
}

let timer = null;
function fnRecorder(newVal){
    clearTimeout(timer);
    timer = setTimeout(()=>{
        const sData = JSON.stringify(newVal);
        localStorage.setItem(sStoargeKey, sData);
    }, 300);
};


const playBetSound = () => {
    sounds.bet.toPlay();
    playWhileDraging();
};


const playResultSound = (isWin) => {
    if (isWin) {
        sounds.win.toPlay();
    } else {
        sounds.lose.toPlay();
    }
};




onBeforeUnmount(()=>{
    oMusic?.toDestory(); 
});



const sOverLimitPayout = computed(() => {
  const maxWin = joinStore.betttingLimits?.maxWin;
  
  if (!maxWin) return '';
  const product = expectedReward.value;
  if (!(product >= maxWin)) return '';
  isOverLimit.value = true;
  const s1 = product.toLocaleString();
  const s2 = maxWin.toLocaleString();
  // eslint-disable-next-line no-console
  console.log(`超限监测：${s1} > ${s2}, 已经超限`);
  
  const { t: $tFn } = useNuxtApp().$i18n;
  const sCurrency = (settingStore.pickedCurrency || '').toUpperCase();
  return $tFn('commonInfo.payoutOverLimit', {
    limit: `${s2} ${sCurrency}`,
  });
});



</script>

<style lang="scss" scoped>
.counterTabs {
    background-color: rgb(1, 25, 56);
    border-right: 1px solid rgb(112, 138, 169);
    border-bottom: 1px solid rgb(112, 138, 169);
    border-left: 1px solid rgb(112, 138, 169);
    border-image: initial;
    border-radius: 0px 0px 10px 10px;
    border-top: none;
    height: 38px;
    width: 100%;
}

.bg {
    // background-size: 150% 83%;
    // background-repeat: no-repeat;

    // background-position: 54% -68%;
}


.board-mid {
    margin: 0 auto;
    max-width: 477px;
    position: relative;
    width: 90%;
    // height: 100px; 
    @media (max-width: 550px) {
        width: 100%;
    }
    .board-mid-container {
        padding-top: 10px;
        flex-direction: column;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }
}
.active-jackpot {
    background: #24e34d;
    color: #1c2532;
}
.over-limit-tips{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0px 16px;
  text-align: center;
  color: white; 
  font-size: 14px; 
  text-shadow: 1px 1px 0px rgb(0, 0, 0, 0.3);
}
</style>
